// src/features/ad-form/constants/units.js
// No need for 'import { t } from 'i18next';' here
export const units = [
    "piece",
    "kilogram",
    "ton",
    "liter",
    "hectare",
    "square_meter",
    "cubic_meter",
    "bag",
    "centner",
    "head",
    "pair",
    "meter",
    "box"
];